import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

const PopupDialog = (props) => {
    const { title, size = "lg", allowClose, closeLabel, closeHandle, doLabel, doHandle, doDisabled = false, linkTo, linkToLabel, show, children, zIndex, footerContent, ...rest } = props
    const navigate = useNavigate()


    const handleGoTo = event => {
        closeHandle()
        navigate(linkTo)
    }
    return (
        <Modal size={size} isOpen={show} backdrop="static" keyboard={false} centered={true} zIndex={zIndex} {...rest}>
            {title && <ModalHeader>
                {title}
            </ModalHeader>}
            <ModalBody>
                {children}
            </ModalBody>
            {(footerContent || linkTo || doHandle || allowClose) && <ModalFooter>
                {footerContent}
                {linkTo &&
                    <Button onClick={handleGoTo} color="primary">
                        {linkToLabel}
                    </Button>
                }
                {' '}
                {doHandle &&
                    <Button
                        color="primary"
                        onClick={doHandle}
                            disabled={doDisabled}
                    >
                        {doLabel}
                    </Button>
                }
                {allowClose &&
                    <Button
                        color="primary"
                        onClick={closeHandle}
                    >
                        {closeLabel}
                    </Button>
                }
            </ModalFooter>}
        </Modal>
    )
}

PopupDialog.defaultProps = {
    closeLabel: "Tutup",
    show: false,
    allowClose: true,
    linkToLabel: "",
    linkTo: "",
    doLabel: "Ya",
    doHandle: null,
    closeHandle: () => { }
}

export default PopupDialog
